module.exports = new __parcel__URL__("machines_bp_blob_cosmetic_level_1.979f5315.png").toString();